import type { CountryCode } from "@config/site/types";
import type { AddressValidatorFunction } from "./types";
import { validateAddressUS } from "./market-validators/us/validateAddressUS";

const validators: Partial<Record<CountryCode, AddressValidatorFunction>> = {
    ["US"]: validateAddressUS,
};

export const getAddressValidator = (market: CountryCode): AddressValidatorFunction | null => {
    // Return market specific validator or null if none exists
    // Market specific validators should implement the AddressValidatorFunction
    return validators[market] ?? null;
};
